import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent, ref, reactive, computed, watch } from "vue";
import { dialogVisibleForStatus, hideDialog, toggleModalVisible } from "@/utils/vue-helpers/modal";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { searchProducts } from "@/db/product-category";
import { generateBookingInvoice, postBookingEmail, sendBookingInvoiceEmail } from "@/api/booking/booking";
import BookingModule from "@/store/modules/booking";
import { getBookingWithUUID } from "@/api/gql/product-slot-boooking";
import { useI18n } from "vue-i18n";
import Timeout from "await-timeout";
import NotificationService from "@/services/notification.service";
import CustomersModule from "@/store/modules/customers";
import { LogLevel, LogService } from "@/services/logging";
import { handleErrorAndPrepareMessage } from "@/utils/helpers/common";
import { EmailTypes } from "@/constants/booking";
import { isBookingUpdated } from "@/utils/vue-helpers/booking";
import { assignOrEditCustomer } from "@/utils/vue-helpers/customer";
import ModalModule from "@/store/modules/modal";
export default defineComponent({
  name: ModalComponents.SendEmail,
  props: {
    modalProps: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var _props$modalProps$pro;

    var modalVisible = dialogVisibleForStatus(ModalStatus.SendEmail);
    var value = ref("");
    var form = ref();
    var isLoading = ref(false);

    var _useI18n = useI18n(),
        t = _useI18n.t;

    var ruleForm = reactive({
      email: CustomersModule.getSelectedCustomerEmail,
      firstName: CustomersModule.getSelectedCustomerFirstName,
      lastName: CustomersModule.getSelectedCustomerLastName
    });
    var emailType = ref(((_props$modalProps$pro = props.modalProps.props) === null || _props$modalProps$pro === void 0 ? void 0 : _props$modalProps$pro.emailType) || EmailTypes.Booking);
    var hasCustomerEmail = computed(function () {
      return CustomersModule.getSelectedCustomerEmail;
    });
    var bookingInfo = ref(null);
    watch(emailType, function () {
      ruleForm.email = CustomersModule.getSelectedCustomerEmail;
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    var checkSpecialCharacters = function checkSpecialCharacters(rule, value, callback) {
      var emailRegex = // eslint-disable-next-line prettier/prettier, no-control-regex
      /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i; // var regex = new RegExp("^[^éèàüöä]+$");

      if (emailRegex.test(value)) {
        return true;
      } else {
        return false;
      }
    }; // TODO: improve email validation logic.


    var rules = reactive({
      email: [{
        type: "email",
        message: t("field.email-invalid"),
        trigger: ["blur", "change"]
      }, {
        validator: checkSpecialCharacters,
        trigger: ["blur", "change"],
        message: t("field.email-invalid")
      }]
    });

    function sendEmail() {
      var _this = this;

      if (!form.value) return;
      form.value.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var _bookingInfo, responseStatus, errorDetails, _errorDetails;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(valid && ruleForm.email)) {
                    _context.next = 42;
                    break;
                  }

                  isLoading.value = true;
                  _context.prev = 2;
                  _bookingInfo = _this.bookingInfo;
                  _context.prev = 4;

                  if (!(emailType.value === EmailTypes.Invoice)) {
                    _context.next = 15;
                    break;
                  }

                  if (!(!(_bookingInfo !== null && _bookingInfo !== void 0 && _bookingInfo.invoiceId) || BookingModule.isEditOrderBooking && isBookingUpdated())) {
                    _context.next = 10;
                    break;
                  }

                  LogService.info("Going to generate an invoice for the booking uuid: ".concat(_bookingInfo.uid));
                  _context.next = 10;
                  return generateBookingInvoice(Number(_bookingInfo === null || _bookingInfo === void 0 ? void 0 : _bookingInfo.id));

                case 10:
                  LogService.info("Emailing the booking inovice, booking uuid ".concat(_bookingInfo.uid, " to the user email address ").concat(ruleForm.email)); // send the invoice email

                  _context.next = 13;
                  return sendBookingInvoiceEmail(Number(_bookingInfo === null || _bookingInfo === void 0 ? void 0 : _bookingInfo.id), 1);

                case 13:
                  _context.next = 19;
                  break;

                case 15:
                  LogService.info("Emailing the booking uuid ".concat(_bookingInfo.uid, " to the user email address ").concat(ruleForm.email)); // eslint-disable-next-line @typescript-eslint/no-unused-vars

                  _context.next = 18;
                  return postBookingEmail({
                    email: ruleForm.email,
                    bookingId: _bookingInfo === null || _bookingInfo === void 0 ? void 0 : _bookingInfo.id,
                    first_name: ruleForm.firstName,
                    last_name: ruleForm.lastName
                  });

                case 18:
                  responseStatus = _context.sent;

                case 19:
                  hideDialog();
                  NotificationService.showCustomSuccess(t("completeorder.email-tickets-success")); // eslint-disable-next-line @typescript-eslint/no-explicit-any

                  _context.next = 30;
                  break;

                case 23:
                  _context.prev = 23;
                  _context.t0 = _context["catch"](4);
                  errorDetails = handleErrorAndPrepareMessage(_context.t0);
                  console.log("errorDetails");
                  console.log(errorDetails);
                  LogService.info("".concat(errorDetails.errorType, " Error when emailing booking with uuid: ").concat(_bookingInfo === null || _bookingInfo === void 0 ? void 0 : _bookingInfo.uid), {
                    params: {
                      err: _context.t0,
                      errorDetails: errorDetails
                    }
                  }, LogLevel.Error);
                  NotificationService.showCustomMessage(errorDetails.errorMessage, "error");

                case 30:
                  _context.next = 37;
                  break;

                case 32:
                  _context.prev = 32;
                  _context.t1 = _context["catch"](2);
                  _errorDetails = handleErrorAndPrepareMessage(_context.t1);
                  LogService.info("".concat(_errorDetails.errorType, " Error when emailing booking with uuid: ").concat(BookingModule.selectedBookingUUID), {
                    params: {
                      err: _context.t1,
                      errorDetails: _errorDetails
                    }
                  }, LogLevel.Error);
                  NotificationService.showCustomMessage(_errorDetails.errorMessage, "error");

                case 37:
                  _context.prev = 37;
                  isLoading.value = false;
                  return _context.finish(37);

                case 40:
                  _context.next = 44;
                  break;

                case 42:
                  isLoading.value = false;
                  return _context.abrupt("return", false);

                case 44:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 32, 37, 40], [4, 23]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    var resetForm = function resetForm() {
      if (!form.value) return;
      form.value.resetFields();
      toggleModalVisible(ModalStatus.Hidden);
    };

    return {
      modalVisible: modalVisible,
      searchProducts: searchProducts,
      form: form,
      ruleForm: ruleForm,
      rules: rules,
      resetForm: resetForm,
      isLoading: isLoading,
      sendEmail: sendEmail,
      value: value,
      EmailTypes: EmailTypes,
      emailType: emailType,
      hasCustomerEmail: hasCustomerEmail,
      assignOrEditCustomer: assignOrEditCustomer,
      bookingInfo: bookingInfo,
      ModalStatus: ModalStatus
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var uid, bookingInfo, retries;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // keep showing the spinner until the booking gets synced
              uid = BookingModule.selectedBookingUUID;

              if (uid) {
                _context2.next = 3;
                break;
              }

              throw new Error("No uuid for this booking");

            case 3:
              retries = 0;

            case 4:
              if (!(!bookingInfo && retries < 5)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 7;
              return getBookingWithUUID(uid);

            case 7:
              bookingInfo = _context2.sent;
              LogService.info("Booking with uuid: ".concat(uid, " was not found when sending email, retrying in 3000ms"));
              retries++;
              _context2.next = 12;
              return Timeout.set(3000);

            case 12:
              _context2.next = 4;
              break;

            case 14:
              if (bookingInfo) {
                _context2.next = 19;
                break;
              }

              // synching failed
              LogService.info("Booking with uuid: ".concat(uid, " was not found when sending email, stopped retrying"));
              NotificationService.showGeneralResponseError();
              ModalModule.setStatus(ModalStatus.Hidden);
              return _context2.abrupt("return");

            case 19:
              _this2.bookingInfo = bookingInfo;

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});